import React from 'react';

export default class ProgramContentEntriesTableHeader extends React.Component {
  render() {
    const { showActions } = this.props;

    return (
      <thead>
        <tr>
          <th>Title</th>
          <th>Description</th>
          {showActions && <th>Actions</th>}
          <th></th>
        </tr>
      </thead>
    );
  }
}
